<med-form-webservice
    *ngIf="profileField$ | async as profileField"
    [id]="profileField.FieldDefinition.FlatKey"
    [label]="profileField.DisplayLabel"
    [labelIcons]="labelIcons"
    [helpText]="profileField.Description"
    [control]="control$ | async"
    [webserviceConfig]="webserviceConfig"
    [multiple]="multiple"
    [records]="records$ | async"
    [errorMsg]="(errorMsg$ | async) || '' | translate"
    [canBeIndeterminate]="canBeIndeterminate"
    [indeterminateMsg]="'general.different-values' | translate"
    [disabledMsg]="disabledMessageKey | translate"
>
    <ng-content></ng-content>
</med-form-webservice>
